import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as ArrowDownIcon } from "../Icons/vuesax/arrow-down.svg";
import { useTDAuthentication } from "auth/AuthenticationProvider";

interface DropdownFilterProps {
  options: string[];
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
  label: string;
}

const DropdownFilter: React.FC<DropdownFilterProps> = ({
  options,
  selectedOptions,
  setSelectedOptions,
  label
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const { accountId, webDUser } = useTDAuthentication();
  useEffect(() => {
    setIsOpen(false);
  }, [accountId]);

  const buttonStyle = {
    backgroundColor: "#fafafa",
    padding: "4px 12px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "15.62px",
    display: "inline-block",
    alignItems: "center",
    marginRight: "8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    borderRadius: "0.75rem",
    border: "1px solid rgba(119, 119, 119, 0.30)"
  };
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  const handleOptionClick = (option: string) => {
    setSelectedOptions(prev => {
      if (prev.includes(option)) {
        return prev.filter(item => item !== option);
      }
      return [...prev, option];
    });
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={toggleDropdown}
        style={{ ...buttonStyle, height: "24px", minWidth:"130px", maxWidth:"130px" }}>
        {label} {selectedOptions.length == 0 ? "" : `(${selectedOptions.length})`}{" "}
        <ArrowDownIcon height="10px" width="10px" style={{ marginLeft: "4px" }} />
      </button>
      {isOpen && options.length > 0 && (
        <ul
          style={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "5px",
            position: "absolute",
            backgroundColor: "#fff",
            zIndex: 1000,
            minWidth: "150px",
            listStyle: "none"
          }}>
          {options.map(option => (
            <li
              key={option}
              onClick={() => handleOptionClick(option)}
              style={{
                padding: "8px",
                cursor: "pointer",
                background: selectedOptions.includes(option)
                  ? "rgba(58, 134, 255, 0.20)"
                  : "transparent"
              }}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownFilter;
